"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports.default = exports.AlarmTimerTitle = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireWildcard(require("react"));

var _TimerStore = require("../../../timing/stores/TimerStore");

var _ReactStaticPage = require("../../../../../react-static/page/ReactStaticPage");

var _Timer = require("../../../timing/components/Timer");

var _TimingBreadcrumb = require("../TimingBreadcrumb");

var _mobxReact = require("mobx-react");

var _class;

var AlarmTimerTitle = "Alarm Timer";
exports.AlarmTimerTitle = AlarmTimerTitle;

var AlarmTimerPage = (0, _mobxReact.observer)(_class =
/*#__PURE__*/
function (_Component) {
  (0, _inheritsLoose2.default)(AlarmTimerPage, _Component);

  function AlarmTimerPage() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = AlarmTimerPage.prototype;

  _proto.render = function render() {
    var title = "Alarm Timer";
    var timerStore = new _TimerStore.TimerStore();
    return _react.default.createElement(_ReactStaticPage.ReactStaticPage, (0, _extends2.default)({
      title: title
    }, this.props), _react.default.createElement(_TimingBreadcrumb.TimingBreadcrumb, null), _react.default.createElement("p", null, "An online alarm timer built with HTML and JavaScript. No Flash plugin required. Works on mobile phones, notebooks, desktop PCs, Macs etc. Load the alarm timer in your web browser or install it on your phone for offline use without using an App Store (coming soon)."), _react.default.createElement("p", null, "We are investigating adding online accounts so you can store different alarm timers and access them across all your devices via the browser. The alarm timer settings would be synchronised when you are online."), _react.default.createElement(_Timer.Timer, {
      timerStore: timerStore
    }));
  };

  return AlarmTimerPage;
}(_react.Component)) || _class;

exports.default = AlarmTimerPage;